/**
 * BedIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BedIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23 15a.2.2 0 0 1 0-.08v-.14a.1.1 0 0 1 0-.05l-2-5.89V6a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2.84l-1.95 5.84a.1.1 0 0 1 0 .05v.14A.22.22 0 0 1 1 15v3a2 2 0 0 0 2 2v1a1 1 0 1 0 2 0v-1h14v1a1 1 0 1 0 2 0v-1a2 2 0 0 0 2-2zM4.72 10h14.56l1.33 4H3.39zM5 6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2H5zM3 18v-2h18v2z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BedIcon = makeIcon('BedIcon', BedIconSvg)
